// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Add, SwapHoriz } from '@/constants/hardfin-standard-icons';
import { useAdjustInventory } from '@/items/hooks/use-adjust-inventory';
import { useTransferInventory } from '@/items/hooks/use-transfer-inventory';
import { getEffectiveLocationName } from '@/location/utilities/get-effective-third-party';
import { SparseItem, SparseLocation } from '@/sparse/api/types';
import { Button, Stack } from '@mui/material';

interface InventoryChildRowActionsProps {
  location?: SparseLocation;
  item?: SparseItem;
  quantity?: number;
}

/**
 * Renders action buttons for inventory child rows.
 */
export function InventoryChildRowActions(props: InventoryChildRowActionsProps) {
  const { openDialog: openAdjustDialog } = useAdjustInventory();
  const { openDialog: openTransferDialog } = useTransferInventory();

  const handleAdjust = () => {
    openAdjustDialog({
      location: props.location,
      item: props.item,
    });
  };

  const handleTransfer = () => {
    openTransferDialog({
      location: props.location && {
        ...props.location,
        name: `${getEffectiveLocationName(props.location)} (${props.quantity ?? 0} available)`,
      },
      item: props.item,
    });
  };

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      spacing={1}
      sx={{
        '& .MuiSvgIcon-root': {
          fontSize: '0.75rem',
        },
      }}
    >
      <Button
        size="small"
        color={'primary'}
        startIcon={<Add />}
        onClick={handleAdjust}
      >
        Adjust
      </Button>
      <Button
        size="small"
        color={'primary'}
        startIcon={<SwapHoriz />}
        onClick={handleTransfer}
      >
        Transfer
      </Button>
    </Stack>
  );
}
